<app-preloader></app-preloader>
<app-navbar *ngIf="!(router.url === '/login' || router.url === '/register')"></app-navbar>
    <router-outlet></router-outlet>
<app-footer *ngIf="!(router.url === '/login' || router.url === '/register')"></app-footer>
